import { render, staticRenderFns } from "./Audiograma.vue?vue&type=template&id=68551d1f&"
import script from "./Audiograma.vue?vue&type=script&lang=js&"
export * from "./Audiograma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports